var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.authResult.checkin &&
    _vm.authResult.checkin[0] &&
    _vm.authResult.checkin[0].name &&
    _vm.authResult.checkin[0].name.length > 0
  )?_c('v-list-item',[(_vm.$store.state.session.mode !== 'permanent-only')?_c('v-list-item-avatar',[_c('checked-in-person-avatar')],1):_vm._e(),_c('v-list-item-content',[(_vm.$store.state.session.mode !== 'permanent-only')?_c('v-list-item-title',[_vm._v(_vm._s(_vm.authResult.checkin[0].name))]):_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t("login.room")))]),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.authResult.checkin[0].room))])],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }